export const palettes = [
  {
    palette: {
      primary: {
        main: '#231942ee',
      },
      secondary: {
        main: '#de5fd0',
      },
      background: {
        default: '#eee',
      },
    },
  },
  {
    palette: {
      primary: {
        main: '#231942',
      },
      secondary: {
        main: '#f2af29',
      },
      background: {
        default: '#fff',
      },
    },
  },

  {
    palette: {
      primary: {
        main: '#B0228C',
      },
      secondary: {
        main: '#f5cac3',
      },
      background: {
        default: '#F8F5F5',
      },
    },
  },
  {
    palette: {
      primary: {
        main: '#472D30',
      },
      secondary: {
        main: '#929487',
      },
      background: {
        default: '#F8F5F5',
      },
    },
  },
  {
    palette: {
      primary: {
        main: '#252B3B',
      },
      secondary: {
        main: '#FFC107',
      },
      background: {
        default: '#fff',
      },
    },
  },
  {
    palette: {
      primary: {
        main: '#0068B8',
      },
      secondary: {
        main: '#c6ac8f',
      },
      background: {
        default: '#F8F5F5',
      },
    },
  },
  {
    palette: {
      primary: {
        main: '#2c3996',
      },
      secondary: {
        main: '#FFC107',
      },
      background: {
        default: '#F8F5F5',
      },
    },
  },
  {
    palette: {
      primary: {
        main: '#065535',
      },
      secondary: {
        main: '#dcedc1',
      },
      background: {
        default: '#F3F4F8',
      },
    },
  },
  {
    palette: {
      primary: {
        main: '#340100',
      },
      secondary: {
        main: '#929487',
      },
      background: {
        default: '#F3F4F8',
      },
    },
  },
  {
    palette: {
      primary: {
        main: '#197278',
      },
      secondary: {
        main: '#edddd4',
      },
      background: {
        default: '#F3F4F8',
      },
    },
  },
  {
    palette: {
      primary: {
        main: '#006DDB',
      },
      secondary: {
        main: '#f7c548',
      },
      background: {
        default: '#F3F4F8',
      },
    },
  },
  {
    palette: {
      primary: {
        main: '#212B36',
      },
      secondary: {
        main: '#30CA6E',
      },
      background: {
        default: '#F3F4F8',
      },
    },
  },
  {
    palette: {
      primary: {
        main: '#600E27',
      },
      secondary: {
        main: '#edddd4',
      },
      background: {
        default: '#F3F4F8',
      },
    },
  },
];
